import type { MutableRefObject } from 'react';
import { useLayoutEffect, useRef, useState } from 'react';

type useHiddenOptionsProps = {
  parentRef: MutableRefObject<HTMLButtonElement | null>;
  selectedOptionsLength: number;
  onHide: (isHidden: boolean) => void;
  gutterWidth?: number;
  isFirst: boolean;
};

const COUNTER_WIDTH = 40;

export const useHiddenOptions = ({
  gutterWidth = 0,
  parentRef,
  selectedOptionsLength,
  onHide,
  isFirst,
}: useHiddenOptionsProps) => {
  const optionRef = useRef<HTMLDivElement | null>(null);

  const [optionIsHidden, setHiddenOption] = useState(false);

  useLayoutEffect(() => {
    if (parentRef.current && optionRef.current) {
      const parentRect = parentRef.current.getBoundingClientRect();
      const parentRight = parentRect.right;

      const optionMaxWidth =
        parentRect.width - gutterWidth - (isFirst && selectedOptionsLength === 1 ? 0 : COUNTER_WIDTH);

      optionRef.current.style.maxWidth = `${optionMaxWidth}px`;

      const optionRight = optionRef.current.getBoundingClientRect().right + gutterWidth;

      if (!isFirst && selectedOptionsLength > 1 && optionRight > parentRight) {
        setHiddenOption(true);
        onHide(true);
      } else {
        setHiddenOption(false);
        onHide(false);
      }
    }

    return () => onHide(false);
  }, [selectedOptionsLength]);

  return { optionIsHidden, optionRef };
};
